import { render, staticRenderFns } from "./GuaranteesWorks.vue?vue&type=template&id=320a1726"
import script from "./GuaranteesWorks.vue?vue&type=script&lang=js"
export * from "./GuaranteesWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports